module.exports = __webpack_public_path__ + "static/media/printStep2.86a172b6.png";